


































































































































































































































import {
  DetailsHeaderActionDispatcher,
  FooterActionDispatcher,
  OpportunityAddMember,
  OpportunityCandidates,
  OpportunityIcon,
  OpportunityInfo,
  OpportunityMembers,
  OpportunityStatus,
  OpportunityTags,
} from '@/components/opportunities';
import {
  AfterCreatingOpportunityModal,
  SendMessageOpportunityModal,
  CancelOpportunityModal,
  ConfirmLaunchModal,
  ConfirmLeaveModal,
  DeleteOpportunityModal,
  GiveFeedbackOpportunityModal,
  MembershipStatusChangeModal,
  RejectCandidateModal,
  RejectOpportunityModal,
  SetGeekJobInfoModal,
} from '@/components/opportunities/modals';
import { GeekItem, Permission } from '@/models';
import { OpportunityItemStatus, OpportunityMembershipStatus, Opportunity } from '@/models/opportunities';
import { Actions, Getters, typedStore } from '@/store';
import { buildGeekFullName, ToastsService } from '@/utils';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import { TranslateResult } from 'vue-i18n';

export default Vue.extend({
  name: 'OpportunityDetailsView',
  props: {
    showAfterCreatingOpportunityModal: {
      type: String,
      default: '',
    },
  },
  components: {
    SendMessageOpportunityModal,
    CancelOpportunityModal,
    ConfirmLaunchModal,
    ConfirmLeaveModal,
    DeleteOpportunityModal,
    DetailsHeaderActionDispatcher,
    FooterActionDispatcher,
    GiveFeedbackOpportunityModal,
    MembershipStatusChangeModal,
    OpportunityAddMember,
    OpportunityCandidates,
    OpportunityIcon,
    OpportunityStatus,
    OpportunityTags,
    OpportunityInfo,
    OpportunityMembers,
    RejectCandidateModal,
    RejectOpportunityModal,
    SetGeekJobInfoModal,
    AfterCreatingOpportunityModal,
  },
  data() {
    return {
      geekToReject: {} as GeekItem,
      loader: {
        isOpportunityDetailsPending: true,
      },
    };
  },
  created() {
    this.fetchOpportunity();
  },
  computed: {
    isGeeksListDisplayed(): boolean {
      return [
        OpportunityItemStatus.Recruiting,
        OpportunityItemStatus.Ongoing,
        OpportunityItemStatus.Finalized,
        OpportunityItemStatus.Canceled,
      ].includes(this.opportunity.status);
    },
    isOneOfInactiveStatuses(): boolean {
      return [
        OpportunityItemStatus.Rejected,
        OpportunityItemStatus.Canceled,
        OpportunityItemStatus.Deleted,
      ].includes(this.opportunity.status);
    },
    areOpportunityCandidatesDisplayed(): boolean {
      return (this.opportunity.issuer.id === typedStore(this).state.geek.current.id
        || typedStore(this).state.geek.current.permissions.includes(Permission.OpportunityManage))
        && this.opportunity.status === OpportunityItemStatus.Recruiting;
    },
    areOpportunityMembersDisplayed(): boolean {
      return [OpportunityItemStatus.Ongoing, OpportunityItemStatus.Finalized].includes(this.opportunity.status);
    },
    canMembersBeAdded(): boolean {
      return (this.opportunity.issuer.id === typedStore(this).state.geek.current.id
        || typedStore(this).state.geek.current.permissions.includes(Permission.OpportunityManage))
        && this.opportunity.status === OpportunityItemStatus.Ongoing;
    },
    opportunity(): Opportunity {
      return typedStore(this).state.opportunities.current;
    },
    opportunityMembershipStatus(): typeof OpportunityMembershipStatus {
      return OpportunityMembershipStatus;
    },
    reasonLabel(): string {
      let reasonLabel: TranslateResult;
      switch (this.opportunity.status) {
        case OpportunityItemStatus.Rejected:
          reasonLabel = this.$t('opportunities.details.labels.rejection-reason');
          break;
        case OpportunityItemStatus.Canceled:
          reasonLabel = this.$t('opportunities.details.labels.cancelation-reason');
          break;
        case OpportunityItemStatus.Deleted:
          reasonLabel = this.$t('opportunities.details.labels.deletion-reason');
          break;
        default:
          return '';
      }
      return reasonLabel as string;
    },
  },
  methods: {
    async fetchOpportunity() {
      this.loader.isOpportunityDetailsPending = true;
      try {
        await this.$store.dispatch(Actions.opportunities.fetchCurrent, this.$route.params.id);
      } finally {
        this.loader.isOpportunityDetailsPending = false;
      }
    },
    async applyToOpportunity() {
      this.loader.isOpportunityDetailsPending = true;
      try {
        await this.$store.dispatch(
          Actions.opportunities.changeMembershipStatus,
          { id: this.$route.params.id, status: OpportunityMembershipStatus.Waiting },
        );
        this.$bvModal.show('status-change-opportunity-modal');
        this.fetchOpportunity();
      } finally {
        this.loader.isOpportunityDetailsPending = false;
      }
    },
    async approveOpportunity() {
      this.loader.isOpportunityDetailsPending = true;
      try {
        await this.$store.dispatch(
          Actions.opportunities.approveOpportunity,
          this.opportunity.id,
        );
        ToastsService.success(this.$t('opportunities.details.notifications.approve') as string);
        this.fetchOpportunity();
      } finally {
        this.loader.isOpportunityDetailsPending = false;
      }
    },
    async approveCandidate(geek: GeekItem) {
      this.loader.isOpportunityDetailsPending = true;
      try {
        await this.$store.dispatch(
          Actions.opportunities.changeCandidateStatus,
          {
            opportunityId: this.$route.params.id,
            geekId: geek.id,
            status: OpportunityMembershipStatus.Accepted,
          },
        );

        const toastText =
          this.$t('opportunities.details.notifications.status-change',
            {
              status: this.$t('opportunities.membershipStatuses.accepted'),
              firstName: geek.firstName,
              nick: geek.nick,
              lastName: geek.lastName,
            },
          ) as string;
        ToastsService.success(toastText);
        this.fetchOpportunity();
      } finally {
        this.loader.isOpportunityDetailsPending = false;
      }
    },
    openSendMessageModal() {
      this.$bvModal.show('send-message-opportunity-modal');
    },
    openGiveFeedbackModal() {
      this.$bvModal.show('give-feedback-opportunity-modal');
    },
    openRejectModal() {
      this.$bvModal.show('reject-opportunity-modal');
    },
    openDeleteModal() {
      this.$bvModal.show('delete-opportunity-modal');
    },
    openCancelModal() {
      this.$bvModal.show('cancel-opportunity-modal');
    },
    openApplyModal() {
      this.$bvModal.show('set-geek-job-info-modal');
    },
    openLeaveModal() {
      this.$bvModal.show('confirm-leave-opportunity-modal');
    },
    openLaunchModal() {
      this.$bvModal.show('confirm-launch-opportunity-modal');
    },
    openRejectCandidateModal(geek: GeekItem) {
      this.geekToReject = geek;
      this.$bvModal.show('reject-candidate-modal');
    },
    buildGeekFullName,
  },
});
